module.exports = __webpack_public_path__ + "img/qr-icon.7c89a1fc.svg";